import { useLingui } from '@lingui/react/macro'

import Input from '@/components/ui/Input'
import Title from './Title'
import InputTile from './InputTile'

interface Props {
  name: string
  slug: string
}

export default function Name({ name, slug }: Props) {
  const { t } = useLingui()

  return (
    <InputTile>
      <Title
        title={t`Name`}
        description={t`Your name and subdomain, please reach out to our support to change this information.`}
      />
      <Input
        value={name}
        // TODO: Disabled for now
        readOnly
      />
      <div className="flex flex-row items-center gap-1">
        <Input
          value={slug}
          // TODO: Disabled for now
          readOnly
        />
        <span className="text-regular text-text">.guestgoodie.com</span>
      </div>
    </InputTile>
  )
}
